import { Controller } from "@hotwired/stimulus";

const LOADER_CLASSES = "absolute bg-gray-100 opacity-10 w-full h-full";

export default class extends Controller {
  static targets = [
    "validationTypeFieldInput",
    "parametersFieldInput"
  ];

  static values = {
    view: String,
  };

  async connect() {
    if (["edit", "new"].includes(this.viewValue)) {
      await this.onValidationTypeChange();
    }
  }

  async onValidationTypeChange() {
    if (this.hasValidationTypeFieldInputTarget && this.validationTypeFieldInputTarget) {
      const validation_type = this.validationTypeFieldInputTarget.value;
      
      try {
        const schema = await this.fetchSchemaForValidationType(validation_type);
        if (this.hasParametersFieldInputTarget) {
          const keyValueController = this.getKeyValueController(this.parametersFieldInputTarget);
          if (keyValueController) {
            const schemaContent = typeof schema === 'string' ? schema : JSON.stringify(schema);
            keyValueController.setContents(schemaContent);
          }
        }
      } catch (error) {
        console.error("Error in onValidationTypeChange:", error);
      }
    } else {
      console.warn("Missing validation type field input target");
    }
  }

  getKeyValueController(element) {
    const keyValueElement = element.closest('[data-controller~="key-value"]');
    if (!keyValueElement) return null;

    return this.application.getControllerForElementAndIdentifier(
      keyValueElement,
      'key-value'
    );
  }

  async fetchSchemaForValidationType(validation_type) {
    if (!validation_type) return [];

    this.loading = true;

    try {
      const url = `${window.Avo.configuration.root_path}/resources/step_validations/validation_schema?validation_type=${validation_type}`;
      const response = await fetch(url);
      
      if (!response.ok) {
        console.error("Fetch failed with status:", response.status);
        return [];
      }
      
      return await response.json();
    } catch (error) {
      console.error("Error fetching schema:", error);
      return [];
    } finally {
      this.loading = false;
    }
  }
}
